import services from '../config/services.json';

export default function ServiceChips({ selected, onToggle, onAll }) {
  const list = services.services.filter((s) => s.active);
  const allActive = selected.length === 0;
  return (
    <div className="hb-chips" role="group" aria-label="Filter by streaming service">
      <button
        type="button"
        className={'hb-chip' + (allActive ? ' is-active' : '')}
        onClick={onAll}
      >
        All Services
      </button>
      {list.map((s) => {
        const active = selected.includes(s.id);
        return (
          <button
            type="button"
            key={s.id}
            className={'hb-chip' + (active ? ' is-active' : '')}
            style={active ? { background: s.color, borderColor: s.color, color: pickTextColor(s.color) } : undefined}
            onClick={() => onToggle(s.id)}
          >
            {s.name}
          </button>
        );
      })}
    </div>
  );
}

function pickTextColor(hex) {
  // Simple luminance check for readable text on the brand background.
  const c = hex.replace('#', '');
  const r = parseInt(c.substr(0, 2), 16);
  const g = parseInt(c.substr(2, 2), 16);
  const b = parseInt(c.substr(4, 2), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? '#1B3F8B' : '#FFFFFF';
}
